<script setup>
import TheWelcome from '../components/TheWelcome.vue'
</script>

<template>
  <main>
    <Suspense>
      <TheWelcome />
    </Suspense>
  </main>
</template>
